import { Directive, Output, Input, EventEmitter, HostBinding, HostListener } from '@angular/core';
import { LxmMessage } from '../_helpers';
import { addFileExtensions } from '../util/fn';

@Directive({
  selector: '[fileDrop]'
})
export class FileDropDirective {

  @Output() onFileDropped = new EventEmitter<any>();

  @Input() accept: string;
  @Input() multiple: boolean;
  @Input() validate: boolean = false; // Default false to not break anything, requires testing

  @HostBinding('style.background-color') private _background;
  @HostBinding('style.opacity') private _opacity;

  constructor(private _msg: LxmMessage) {}

  public emitFiles(files) {
    if (files.length > 0) {
      this.onFileDropped.emit(files);
    }
  }

  public get addFileExtensions() {
    return addFileExtensions(this.accept);
  }

  // Click listener
  @HostListener('click', ['$event']) onClick(evt) {

    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.accept = this.accept;
    if (this.multiple) {
      inputElement.multiple = true;
    }

    inputElement.addEventListener('change', () => {
      this.emitFiles(inputElement.files);
    });

    inputElement.dispatchEvent(new MouseEvent('click'));
  }

  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this._background = '#9ecbec';
    this._opacity = '0.8';
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this._background = '#f5fcff';
    this._opacity = '1';
  }

  // Drop listener
  @HostListener('drop', ['$event']) public ondrop(evt) {
    evt.preventDefault();
    // evt.stopPropagation();
    this._background = 'transparent';
    this._opacity = '1';
    
    if (this.validate) {
      // Check if dropped file is accepted
      for (const file of evt.dataTransfer.files) {
        if (!this.accept.includes(file.type)) {

          const params = this.accept ? {
            messageKey: "directives.file_drop.file_type_not_supported_with_extensions",
            messageKeyParams: { addFileExtensions: this.addFileExtensions },
          } : {
            messageKey: "directives.file_drop.file_type_not_supported",
          }

          this._msg.error(params);
          return;
        }
      }
    }

    this.emitFiles(evt.dataTransfer.files);
  }
}


export const ACCEPTED_IMAGE_TYPES = 'image/png, image/jpeg, image/gif, image/bmp';